export interface AddToBasketResponse {
  statusCode: number
  body?: unknown
}


type AddToBasketSuccessResponse = {
  statusCode: number
  body: {
    basket_count: number
    item_id: number
  }
}
const isAddToBasketSuccessResponse = (response: AddToBasketResponse): response is AddToBasketSuccessResponse => {
  return (
    response.statusCode === 200
    && (response as AddToBasketSuccessResponse)?.body?.basket_count !== undefined
  )
}

type AddToBasketFailureResponse = {
  statusCode: number
  body: {
    type: string
    message: string
  }
}

const isAddToBasketFailureResponse = (response: AddToBasketResponse, type: string, expectedStatusCode: number = 422): response is AddToBasketFailureResponse => {
  return (
    response.statusCode === expectedStatusCode
    && (response as AddToBasketFailureResponse)?.body?.type === type
    && typeof (response as AddToBasketFailureResponse)?.body?.message === 'string'
  )
}

export const parseAddToBasketResponse = (response: AddToBasketResponse): AddToBasketSuccess | AddToBasketFailure => {
  if (isAddToBasketSuccessResponse(response)) {
    return new AddToBasketSuccess(response.body.basket_count, response.body.item_id)
  }
  if (isAddToBasketFailureResponse(response, 'NotEnoughStockDTO')) {
    return new AddToBasketInlineError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'UnderMinimumOrderQuantityDTO')) {
    return new AddToBasketInlineError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'OverMaximumOrderQuantityDTO')) {
    return new AddToBasketInlineError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'NotMultipleOfOrderQuantityDTO')) {
    return new AddToBasketInlineError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'OverContractQuantityDTO')) {
    return new AddToBasketInlineError(response.body.message)
  }

  if (isAddToBasketFailureResponse(response, 'ProductNotOfferedDTO')) {
    return new AddToBasketModalError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'CannotAddContractForProductDTO')) {
    return new AddToBasketModalError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'CannotAddContractForPartyDTO')) {
    return new AddToBasketModalError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'PreOrderCatalogDoesNotMatchDTO')) {
    return new AddToBasketModalError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'PreOrderCatalogExpiredDTO')) {
    return new AddToBasketModalError(response.body.message)
  }
  if (isAddToBasketFailureResponse(response, 'QuotationInBasketDTO', 400)) {
    return new AddToBasketModalError(response.body.message)
  }

  throw new ParseAddToBasketResponseError()
}


export class AddToBasketSuccess {
  basketCount: number
  itemId: number

  constructor(basketCount: number, itemId: number) {
    this.basketCount = basketCount
    this.itemId = itemId
  }
}


export type AddToBasketFailure = AddToBasketInlineError | AddToBasketModalError

export class AddToBasketInlineError  {
  message: string

  constructor(message: string) {
    this.message = message
  }
}


export class AddToBasketModalError  {
  message: string

  constructor(message: string) {
    this.message = message
  }
}


class ParseAddToBasketResponseError extends Error {
  override name = 'ParseAddToBasketResponseError' as const

  constructor() {
    super('Failed to parse AddToBasketResponse')
  }
}
